import Loader from 'common/components/Loader';
import { useGetChampionnatById } from 'features/championnats/championnat.api';
import { useNavigate, useParams } from 'react-router-dom';
import { NotFound } from './ErrorPage';
import { ChampionnatDetail } from 'features/championnats/components/ChampionnatDetail';
import ChampionnatPersonnaliseDetail from 'features/championnats/components/ChampionnatPersonnaliseDetail';
import { RoutePath } from 'router/routes.paths';
import BPCPageHeading from 'common/components/BPCPageHeading';
import { FaEdit, FaPlus } from 'react-icons/fa';
import { useBreakpointValue } from '@chakra-ui/react';
import { useConnectedUserContext } from 'features/user/useConnectedUserContext';

export default function ChampionnatDetailPage() {
  const { id } = useParams<{ id: string }>();
  const { championnat, isLoading } = useGetChampionnatById(id!);
  const navigate = useNavigate();
  const { user } = useConnectedUserContext();
  const modifierTitle = useBreakpointValue(
    { base: '', md: 'Modifier' },
    { fallback: 'md' },
  );

  if (isLoading) {
    return <Loader fullScreen />;
  }

  if (
    !championnat ||
    (championnat.type === 'personnalise' &&
      championnat.createdByPlayerId !== user?.id)
  ) {
    return <NotFound />;
  }

  const { name } = championnat;

  return (
    <>
      <BPCPageHeading
        title={name}
        breadcrumbItems={[
          { to: RoutePath.home, name: 'Home' },
          { to: RoutePath.championnats, name: 'Championnats' },
        ]}
        buttonProps={[
          ...(championnat.type !== 'personnalise'
            ? [
                {
                  leftIcon: <FaPlus />,
                  onClick: () =>
                    navigate(RoutePath.tournoiNew, {
                      state: { tournoi: { championnatId: id } },
                    }),
                  title: 'Créer un tournoi',
                },
              ]
            : []),
          {
            leftIcon: <FaEdit />,
            onClick: () => navigate(`${RoutePath.championnats}/${id}/edition`),
            title: modifierTitle,
          },
        ]}
      />

      {championnat.type === 'personnalise' ? (
        <ChampionnatPersonnaliseDetail championnat={championnat} />
      ) : (
        <ChampionnatDetail championnat={championnat} />
      )}
    </>
  );
}
